const baseUrl = process.env.REACT_APP_BASE_URL;
export const getCheckoutUrlUrl = baseUrl + "payments/checkout";
